import { Alert, Box, CircularProgress, Grid, useTheme } from "@mui/material";
import { KpiCard } from "../../programmeDashboard/components/KpiCard";
import { useBudgetCostPerformance } from "../hooks/useBudgetCostPerformance";
import { formatCurrency } from "../../../shared/utils";

export const BudgetCastState = () => {

    const theme = useTheme();

    const { data: budgetCostPerformanceData, isLoading, isError, error } = useBudgetCostPerformance();

    const kpiData = [
        {
            label: 'Budget vs Actual',
            value: formatCurrency(budgetCostPerformanceData.budget_vs_actual),
            subValue: '£29, 200,000 budget • £18, 750,000 spent',
        },
        {
            label: 'Budget vs EAC',
            value: formatCurrency(budgetCostPerformanceData.budget_vs_eac),
            subValue: '£29, 200,000 budget • £29, 820,000 forecast',
        },
        {
            label: 'Overall Variance',
            value: formatCurrency(budgetCostPerformanceData.budget_vs_eac - budgetCostPerformanceData.budget_vs_actual),
            subValue: '£620,000 over budget',
        },
    ];

    if (isLoading) {
        return (
            <Box
                height="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                width="100%"
                gap={2}
                my={5}
            >
                <CircularProgress />
            </Box>
        )
    };

    if (isError) {
        return (
            <Box
                height="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                width="100%"
            >
                <Alert
                    severity="warning"
                    sx={{
                        width: "auto",
                        justifyContent: "center",
                        textAlign: "center",
                    }}
                >
                    {error?.message || "Something went wrong!"}
                </Alert>
            </Box>
        );
    };

    return (
        <Grid container spacing={2} sx={{ mb: 3 }} px={2}>
            {kpiData.map((item: { label: string; value: string; subValue: string; icon?: React.ReactNode }) => (
                <Grid size={{ xs: 12, sm: 6, md: 4 }} key={item.label}>
                    <KpiCard
                        label={item.label}
                        value={item.value}
                        icon={item.icon}
                        iconColor={theme.palette.info.main}
                        subValue={item.subValue}
                    />
                </Grid>
            ))}
        </Grid>
    );

};